// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5ecf7a39","732":"1886dffc","977":"c5c96c52"}[chunkId] + ".chunk.js";
};